import React from 'react';
import { Table } from 'semantic-ui-react';
import DataManagementDataModelButtonGroup from './DataManagementDataModelButtonGroup';

const DataManagementDataModelActionsCell = ({
  disableValidate,
  isLoading,
  validate,
}) => (
  <Table.Cell singleLine textAlign="center">
    <DataManagementDataModelButtonGroup
      disableValidate={disableValidate || isLoading}
      validate={validate}
    />
  </Table.Cell>
);

export default DataManagementDataModelActionsCell;
